import { Block, Fragment } from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import { BLOCK_EMBED, FRAGMENT_CAPTION } from '../types';

/**
 * Create an embed block, with an optional caption.
 */
export function createEmbedBlock(url: string, caption?: Fragment | string, fullWidth?: boolean) {
    const fragments: Fragment[] = [];

    if (typeof caption === 'undefined' || typeof caption === 'string') {
        fragments.push(
            Fragment.create({
                fragment: FRAGMENT_CAPTION,
                nodes: [createParagraph(caption || '')],
            })
        );
    } else {
        fragments.push(caption);
    }

    return Block.createVoid({
        type: BLOCK_EMBED,
        data: {
            url,
            ...(typeof fullWidth !== 'undefined' ? { fullWidth } : {}),
        },
        fragments,
    });
}
